import { useSyncExternalStore } from "react";

/* Single source of truth for responsive breakpoints.
   Matches Tailwind's md/lg so JS checks and `md:`/`lg:` classes never disagree.
   - mobile  : < 768   (iPhone Pro 390, Pro Max 430)
   - tablet  : 768–1023 (iPad portrait 768/810/834)
   - desktop : >= 1024  (iPad landscape, laptops, monitors) */
export const BREAKPOINTS = { md: 768, lg: 1024 };

const QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.md - 1}px)`,
  tablet: `(min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.lg}px)`,
};

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", cb);
      return () => mql.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}

/* One hook for all layout decisions. Exactly one of the three is true. */
export function useViewport() {
  const isMobile = useMediaQuery(QUERIES.mobile);
  const isTablet = useMediaQuery(QUERIES.tablet);
  return { isMobile, isTablet, isDesktop: !isMobile && !isTablet };
}
